import { render } from "./DefaultLayout.vue?vue&type=template&id=2be95bfb&scoped=true&ts=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"

import "./DefaultLayout.vue?vue&type=style&index=0&id=2be95bfb&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be95bfb"]])

export default __exports__